module.exports = __webpack_public_path__ + "images/company_profile/icon_en07-c7f2caec1dd183665542b0ac4497ad81.png";